// extracted by mini-css-extract-plugin
export default {"scroll":"ScrollableContainer-module__scroll--ALnoS"};